module.exports = __webpack_public_path__ + "img/joystick-white.bcaab880.svg";